import {UseMutationOptions, useMutation, useQueryClient} from '@tanstack/react-query';
import {API, CreateBulkDealPayload} from '@chekin/api';
import {QUERY_CACHE_KEYS, Deal} from '@chekin/core';
import {useIsMounted} from '@chekin/guestapp-ui-kit';

type UseCreateBulkDealMutationProps = UseMutationOptions<
  Deal[],
  Error[],
  CreateBulkDealPayload
>;
function useCreateBulkDealMutation({
  onError,
  onMutate,
  onSettled,
  onSuccess,
}: UseCreateBulkDealMutationProps = {}) {
  const queryClient = useQueryClient();
  const isMounted = useIsMounted();

  return useMutation<Deal[], Error[], CreateBulkDealPayload>({
    mutationFn: payload => API.upselling.createBulkDeal({...payload}),
    onSuccess: (...args) => {
      onSuccess?.(...args);
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.deals],
      });
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.paymentsCart],
      });
    },
    onMutate,
    onError: (...args) => {
      if (!isMounted.current) {
        return;
      }

      onError?.(...args);
    },
    onSettled,
  });
}

export {useCreateBulkDealMutation};
